export const COMPETITOR_COMPARISON = [
  {
    text: 'Countertop Stand (10″ & 15″)',
    them: true,
  },
  {
    text: 'Wall Mount (15″ & 27″)',
    them: true,
  },
  {
    text: 'Multiple Sizes (10″, 15″, 27″)',
    them: true,
  },
  {
    text: 'Subscription-Free Features',
    detail: 'Tasks, Custom Lists, Profiles, Parental Lock & more!',
    them: false,
  },
  {
    text: 'Free, Automatic Software Updates',
    them: false,
  },
  {
    text: '24/7 Email & Phone Support',
    them: false,
  },
  {
    text: '4-Month Money Back Guarantee',
    them: false,
  },
]
